// Remove the "Manage subscriptions" link from the account login page
// https://docs.getrecharge.com/docs/translate-the-customer-account-access-link
window.rcLoginAccessLink = {
  disableInjection: true
};